import { IChartVariant } from './../shared.d';
import { useMemo } from 'react';
import {
  isGlobal,
  filterByGlobal,
  filterPositionOver,
  filterBySelectedVariant,
} from '../helpers/chartFilters';

function removeLocalCharts(chart: any): any {
  // during iteration assignments mutate the original array
  const copy = Object.assign({}, chart);
  copy.territoryData = chart.territoryData.filter(isGlobal);
  return copy;
}

export const getGlobalChartRows = (
  selectedChartVariant?: IChartVariant,
  chartRows?: any[] | null,
  top?: number
): any[] | null => {
  if (chartRows) {
    const result = chartRows
      .filter(filterBySelectedVariant(selectedChartVariant))
      .filter(filterByGlobal)
      .filter(filterPositionOver(200))
      .map(removeLocalCharts);

    return top ? result.splice(0, top) : result;
  }

  return null;
};

/**
 * Filters the specified `chartRows` and returns only those positions that belong to a global chart.
 */
export default function useGlobalChartRows(
  chartRows: any[] | null,
  top?: number,
  selectedChartVariant?: any
): any[] | null {
  return useMemo(
    () => getGlobalChartRows(selectedChartVariant, chartRows, top),
    [chartRows, selectedChartVariant, top]
  );
}
